import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const PositionGroups = {
  List: lazyNamed(() => import('./pages/PositionGroupList/index.tsx'), 'PositionGroupList'),
  PositionGroupForm: lazyNamed(() => import('./pages/PositionGroupForm/index.tsx'), 'PositionGroupForm'),
  PositionsForm: lazyNamed(() => import('./pages/PositionsForm/index.tsx'), 'PositionsForm'),
};
